import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Lifebuoy } from "@phosphor-icons/react/Lifebuoy";
import { MapField, mapPalettes } from "mangomap-ui/src/components/map-field";

import { ContactForm } from "~landing/components/contact/contact-form";

export function Contact() {
	const contactContent = {
		heading: "Talk to the team.",
		subHeading:
			"Questions about pricing, plans, or whether Mango fits your project? Send a message and we'll get back to you.",
	};

	return (
		<Box sx={{ bgcolor: "var(--mui-palette-background-level1)", py: "60px" }}>
			<Container>
				<Box
					sx={{
						borderRadius: "20px",
						border: "1px solid transparent",
						color: "var(--mui-palette-common-white)",
						display: "flex",
						flexDirection: { xs: "column", md: "row" },
						overflow: "hidden",
						position: "relative",
					}}>
					<Box
						sx={{
							bgcolor: "var(--mui-palette-neutral-950)",
							borderRadius: "20px",
							bottom: "1px",
							left: "-1px",
							position: "absolute",
							right: "1px",
							top: "-1px",
							zIndex: 0,
						}}>
						<MapField
							seed="contact"
							variant="parcels"
							strokeWidth={0.5}
							parcelMinSize={5}
							parcelMaxDepth={13}
							aspect="16 / 9"
							animate
							duration={5}
							palette={mapPalettes.onDark}
							style={{ width: "100%", height: "100%", opacity: 0.12 }}
						/>
					</Box>
					<Stack
						direction={{ xs: "column", md: "row" }}
						spacing={3}
						sx={{
							flex: "0 1 auto",
							position: "relative",
							px: "64px",
							py: "64px",
							zIndex: 1,
						}}>
						<Box sx={{ flex: 1 }}>
							<Stack spacing={2}>
								<Typography
									color="inherit"
									variant="h3">
									{contactContent.heading}
								</Typography>
								<Typography color="neutral.300">
									{contactContent.subHeading}
								</Typography>
							</Stack>
							<Box sx={{ flex: 1 }}>
								<Stack
									mt={4}
									spacing={2}>
									<Stack
										alignItems="center"
										direction="row"
										spacing={1}>
										<Lifebuoy
											size={24}
											weight="duotone"
										/>
										<Typography
											color="inherit"
											variant="subtitle2">
											Looking for technical support?{" "}
											<Link
												href="https://help.mangomap.com/hc/en-us/requests/new"
												target="_blank">
												Submit a ticket
											</Link>
										</Typography>
									</Stack>
								</Stack>
							</Box>
						</Box>

						<Box sx={{ flex: 1 }}>
							<Stack spacing={2}>
								<ContactForm />
							</Stack>
						</Box>
					</Stack>
				</Box>
			</Container>
		</Box>
	);
}
